export default {
    //ticket invoice report
    showdate:'Show Date',
    showTime:"Show Time",
    screen:"Screen",
    ticketprice:"Ticket Price",
    ticketnet:"Ticket Net",
    totaltickets:"Total Ticket",
    totalgross:"Total Gross",
    enttax:'Ent. Tax',
    fees:"Fees",
    totaltax:"Total Tax",
    totalvat:"Total Vat",
    totalaftertax:"Total After Tax",
    totalaftervat:"Total After Vat",
    socialsubside:"Social",
    cinemasubside:"Cinema ",
    policesubside:"Police",
    daransubside:"Daran",
    servicessubside:"Service",
    sports:"Sports",
    //cinema tax vat analysis report
    grandtotal:"Grand Total",
    total:"Total",
    distributioncompany:"Distribution Company",
     distributionname:"Distribution Name",
    ticketcosttotal:"Ticket Cost(Total)",
    ticketcostforentry:"Ticket Cost(for entry)",
    ticketscount:"Tickets Count",
    ticketscost:"Tickets Cost",
    amusementtax:"Amusement Tax",
    taxtotal:"Total Tax",
    totalafterasumetax:"Total After Amusement Tax",
    vat:"Vat",
    netaftervat:"Net After Vat",
    tax:"Tax",
    //refund report
    movie: "Movie",
    ticketSerialNo: "Ticket Serial No.",
    user: "User",
    refundTime: "Refund Time",
    sellTime: "Sell Time",
    //cashier settlement report
    showtimes:"show Times",
    tickets:"Tickets",
    ticketsrevenue:"Tickets Revenue",
    "3dglasses":"3D Glasses",
    "3dglassesrevenue":"3D Glasses Revenue",
    paymentmethods:"Payment Methods",
    cashier:"Cashier",
    bookingchannels:"Booking Channels",

    refundTime: "Refund Date Time",
    sellTime: "Sell Date Time",
    //cinema tax screen analysis
    productioncompany:"Production Company",
    ticketscosttotal:"Tickets Cost (total)",
    ticketscostforentry:"Tickets Cost (for entry)",
    type:"Type",
    movie:"Movie",
    egyptian:"Egyptian",
    foreign:"Foreign",
    finalreport:"Final Report",
    ongoingreserve:"Ongoing Reserve",
    //cinema overlall analyisis
    ticketscosttotal:"Tickets Cost(total)",
    ticketscostforentry:"Tickets Cost(for entry)",
    total:"Total",
    grandtotal:"Grand Total",
    ticket_quantity: "Ticket Quantity",
    ticket_price: "Ticket Price",
    reprint_qty: "Reprint Quantity",
    authorized_by: "Authorized By",
    show_date  :"Show Date",
    show_time: "Show Time",
    ref_code: "Ref. Code",
    selling_time: "Selling Time",
    screen: "Screen",
    movie: "Movie",
    reprint_time: "Reprint Date Time",
    //transaction refund report old
    transactionnumber: "Transaction Number",
    bookingdate: "Sell Date/Time",
    date: "Date",
    filmname: "Movie Name",
    screenname: "Screen Name",
    salesChannel: "Sales Channel",
    seatnumber: "Seat Number",
    refundamount: "Refund Amount",
    refunddatetime:"Refund Date & Time",
    minutesaftersessionstarted:"Minutes After Sesssion started",
   refundreason:"Refund Reason",
    refundedby: "Refunded By",
    authorizedby: "Authorized By",
    paymentmode: "Payment Mode",
    customername:"Customer Name",
    mobileno: "Mobile No",
    boremarks:"Bo Remarks",
    //movie overall analysis report
    moviename:"Movie Name",
    distributorcompany:"Distributor Company",
    totaltickets:"Total Tickets",
    totalticketsprice:"Total Ticket Price",
    totaltaxes:"Total Taxes",
    totalvat:" Total Vat",
    totalnet:"Total Net",
    totalPrice: "Total Price",
    concessionHardware: "Concession",
    posUsername: "POS Username",
    qty: "Qty",
    item: "Item",
    username: "Username",
    fnbCourtseyReport: "Fnb Courtsey Report",
    overAllTotal: "Over All Total",
    refundedby: "Refunded By",
    approver: "Approver",
    personalName: "Courtsey Personal",
    refunddatetime: "Refund Date/Time",
    datetime: "Date/Time",
    showDateTime: "Show Date/Time",
    serialNo: "Serial No.",
    noOfTickets: "No. Of Tickets",
    ticketPrice: "Tickets Price",
    forDays: "For Days",
    netProfit: "Net Profit",
    cost: "Cost",
    resone: "Resone",
    total: "Total",
    quantity: "Quantity",
    price: "Price",
    date: "Date",
    itemName: "Item Name",
    totalCost: "Total Cost",
    stock: "Stock",
    item: "Item",
    totalSoldTicket: "Total Sold Ticket",
    TotalSoldTicketsRevenue: "Total Sold Tickets Revenue",
    TotalSold3DGlasses: "Total Sold 3D Glasses",
    TotalSold3DGlassesRevenue: "Total Sold 3D Glasses Revenue",
    TotalPurgedTickets: "Total Purged Tickets",
    TotalPurgedTicketsRevenue: "Total Purged Tickets Revenue",
    TotalPurged3DGlasses: "Total Purged 3D Glasses",
    TotalPurged3DGlassesRevenue: "Total Purged 3D Glasses Revenue",
    TotalSoldTickets: "Total Sold Tickets",
    TotalSoldTicketsRevenue: "Total Sold Tickets Revenue",
    TotalSold3DGlasses: "Total Sold 3D Glasses",
    TotalSold3DGlassesRevenue: "Total Sold 3D Glasses Revenue",
    TotalTicketsGlassesRevenue: "Total (Tickets + Glasses) Revenue",
    Additionalfees: "Additional fees",

    Cost_balance: "Cost Balance",
  Total_Cost: "Total Cost",
  Item_Cost: "Item Cost",
  Item_Request_Form_no: "Item Request Form no",
  Reason: "Reason",
  Stock: "Stock",
  Spend: "Spend",
  Import: "Import",
  Purchase_Return: "Purchase Return",
  Transfer_In: "Transfer In",
  Property_In: "Property In",
  Property_Out: "Property Out",
  Standard_Consumed: "Standard Consumed",
  Wastage: "Wastage",
  Variance: "Variance",
  System_Stock: "System Stock",
  Date: "Date",
  SubWare_House: "SubWare House",
  Main_Ware_House: "Main_Ware House",
distirbutor_share_value: "Distirbutor Share Value",
}


// WEBPACK FOOTER //
// ./src/helper/trans/en.js